import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

type ConfirmDialogProps = {
  planDescription: string;
  open: boolean;
  setOpen: (toggle: boolean) => void;
  handleCancelSubscription: any;
};

const ConfirmCancelSubscriptionDialog: React.FC<ConfirmDialogProps> = ({
  open,
  setOpen,
  planDescription,
  handleCancelSubscription,
}) => {
  const handleDelete = async (e: any) => {
    e.preventDefault();

    handleCancelSubscription();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Cancel Subscription"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {planDescription}. Are you sure you want to cancel your
            subscription?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button onClick={(e) => handleDelete(e)} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConfirmCancelSubscriptionDialog;
